{
  "audit_trail": {
    "button": {
      "text": "Piste d'audit"
    },
    "modal": {
      "header": "Piste d'audit"
    },
    "loading": {
      "aria_label": "chargement des pistes d'audit"
    },
    "table": {
      "current": "Actuel"
    },
    "details": {
      "show_details_aria_label": "afficher les détails"
    },
    "actions": {
      "updated": "mis à jour",
      "deleted": "supprimé",
      "created": "créé"
    },
    "entities": {
      "company_info": "informations de l'entreprise",
      "company_key_contact": "contact clé",
      "company_office_location": "emplacement du bureau",
      "contact_info": "contact",
      "contact": "contact",
      "contact_location": "emplacement du contact",
      "relationship_partner": "partenaire de relation",
      "contact_consent": "consentement marketing",
      "note": "note d'opportunité",
      "opportunity": "opportunité",
      "company_document_file": "fichier"
    }
  }
}
